import { DetailsInfo, Flex, Modal, Text } from '@/components';
import { useMe } from '@/features/authentication/_hooks/me';
import { RoleDetails } from '@/features/tenant-manager/components/role/RoleDetails';
import { useOrganizations } from '@/features/tenant-manager/hooks';
import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const RolePermissionModal: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { data: me } = useMe();

  const organizations = useOrganizations();

  const myOrganizations = useMemo(() => {
    if (!me?.organizationIds.length) {
      return [];
    }
    return me.organizationIds.flatMap((id) => {
      const organization = organizations.data?.find(
        (organization) => organization.id === id,
      );
      return organization ? [organization] : [];
    });
  }, [organizations.data, me?.organizationIds]);

  if (!me?.role) {
    return null;
  }

  return (
    <Modal
      title={t('dev-tools.role-permission-label')}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Flex
        vertical
        // justify="center"
        align="center"
        gap={16}
        style={{ height: '600px', overflowY: 'scroll' }}
      >
        <Text text={t('organization')} />
        <DetailsInfo
          items={myOrganizations.map((v) => {
            return {
              label: v.name,
              value: (
                <Link
                  to={`/tenant-manager/roles/${v.roleId}`}
                  onClick={onClose}
                >
                  {t('dev-tools.role-permission-label')}
                </Link>
              ),
            };
          })}
        />
        <Text text={t('role-name')} />
        <RoleDetails
          role={{
            ...me.role,
            createdAt: '',
            updatedAt: '',
            id: '',
            name: 'ユーザーロール',
          }}
        />
      </Flex>
    </Modal>
  );
};
